import { z } from 'zod';
/**
 * Schemas de autenticacao, compartilhados entre a validacao da API e os
 * formularios do frontend. Uma regra de senha existe em um lugar so.
 */
export const PASSWORD_MIN_LENGTH = 10;
export const passwordSchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, `A senha deve ter ao menos ${PASSWORD_MIN_LENGTH} caracteres`)
    .max(200, 'A senha é longa demais')
    .refine((v) => /[a-z]/.test(v), 'Inclua ao menos uma letra minúscula')
    .refine((v) => /[A-Z]/.test(v), 'Inclua ao menos uma letra maiúscula')
    .refine((v) => /[0-9]/.test(v), 'Inclua ao menos um número');
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .email('E-mail inválido')
    .max(254);
/** Telefone brasileiro: aceita com ou sem mascara, normaliza para digitos. */
export const phoneSchema = z
    .string()
    .trim()
    .transform((v) => v.replace(/\D/g, ''))
    .refine((v) => v.length === 10 || v.length === 11, 'Telefone deve ter DDD + número');
export const registerSchema = z.object({
    name: z.string().trim().min(3, 'Informe o nome completo').max(120),
    email: emailSchema,
    password: passwordSchema,
    phone: phoneSchema,
    /** Tipo pretendido: define o papel base atribuido apos verificar o e-mail. */
    accountType: z.enum(['DRIVER', 'SHIPPER']),
    acceptedTerms: z.literal(true, {
        errorMap: () => ({ message: 'É necessário aceitar os termos de uso' }),
    }),
});
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Informe a senha'),
    /**
     * Segundo fator: o codigo de 6 digitos do aplicativo OU um codigo de
     * recuperacao.
     *
     * Um campo para os dois de proposito. A validacao anterior exigia
     * `/^\d{6}$/`, o que rejeitava os codigos de recuperacao ANTES de chegarem
     * ao servidor — eles eram gerados, impressos e documentados como "se voce
     * perder o celular", mas nao passavam nem pelo schema. Promessa que o sistema
     * nao cumpria, justamente no caminho de quem ja esta sem acesso.
     */
    totp: z
        .string()
        .trim()
        .min(6, 'Informe o código de 6 dígitos ou um código de recuperação')
        .max(40)
        .optional(),
});
export const forgotPasswordSchema = z.object({ email: emailSchema });
export const resetPasswordSchema = z.object({
    token: z.string().min(20),
    password: passwordSchema,
});
export const verifyEmailSchema = z.object({ token: z.string().min(20) });
export const mfaVerifySchema = z.object({
    totp: z.string().trim().regex(/^\d{6}$/, 'O código deve ter 6 dígitos'),
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1),
    newPassword: passwordSchema,
});
export const THEME_VALUES = ['light', 'dark', 'system'];
export const preferencesSchema = z.object({
    theme: z.enum(THEME_VALUES).optional(),
    notifyEmail: z.boolean().optional(),
    notifyPush: z.boolean().optional(),
    notifySms: z.boolean().optional(),
});
//# sourceMappingURL=auth.js.map